import { Button, Intent, Tooltip } from "@focus/focusUI";
import { useMemo } from "react";
import { ROLES, useRoles } from "../../hooks/useRoles";
import { useUserController } from "../../hooks/useUserController";
import type { User } from "../../types/users";

interface RestoreTotpButtonProps {
  user?: User;
  text?: string;
  intent?: Intent;
  disabled?: boolean;
}

export const RestoreTotpButton = ({
  user,
  text,
  intent,
  disabled,
}: RestoreTotpButtonProps) => {
  const { organizations, restoreTotp } = useUserController();
  const { roles } = useRoles();

  const canEdit = useMemo(() => {
    if (roles.includes(ROLES.ADMIN)) return true;
    if (!roles.includes(ROLES.ORG_ADMIN)) return false;

    return (
      user?.organizations?.some((org) => organizations.includes(org)) ?? false
    );
  }, [roles, organizations, user?.organizations]);

  if (!canEdit) return null;

  return (
    <Tooltip content={text ? undefined : "Restore TOTP"}>
      <Button
        text={text}
        intent={intent}
        icon="key"
        minimal={!intent}
        onClick={() => restoreTotp(user.id)}
        disabled={disabled}
      />
    </Tooltip>
  );
};
